import type { CompanyColorScheme } from '../data'

export interface NormalizedCompanyColorScheme {
  occupancy_colors: Record<string, string>
  trigger_colors: Record<string, string>
  schedule_colors: Record<string, string>
}

export const DEFAULT_OCCUPANCY_COLORS: Record<string, string> = {
  free: 'green',
  occupied: 'red',
}

export function normalizeCompanyColorScheme(colorScheme?: CompanyColorScheme): NormalizedCompanyColorScheme {
  const occupancyColors = colorScheme?.occupancy_colors

  return {
    occupancy_colors: occupancyColors && Object.keys(occupancyColors).length > 0 ? occupancyColors : { ...DEFAULT_OCCUPANCY_COLORS },
    trigger_colors: colorScheme?.trigger_colors || {},
    schedule_colors: colorScheme?.schedule_colors || {},
  }
}
